import React from "react"
import * as styles from "./SpeechBabble.module.css"

type SpeechBabbleProps = {
  children: React.ReactElement
}

const SpeechBabble = ({ children }: SpeechBabbleProps) => {
  return (
    <div className={styles.container}>
      {typeof children === "string" ? (
        <p className={styles.text}>{children}</p>
      ) : (
        <p className={styles.text}>{children.props.children}</p>
      )}
    </div>
  )
}

export default SpeechBabble
